import { render, staticRenderFns } from "./PesquisasDash2.vue?vue&type=template&id=392b2044&"
import script from "./PesquisasDash2.vue?vue&type=script&lang=js&"
export * from "./PesquisasDash2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports